/* Button shape on every page: pill on three corners, 45° chamfer top-right (the same path core-pdp.js draws on the
   product pages). The homepage lost its chamfer when core-system, which carried core-pdp.js, came off the template. */
(function () {
  function ctaPath(W, H) {
    var r = 5, c = Math.max(12, Math.round(H * .32)), k = 4, d = k / Math.SQRT2;
    return 'M' + r + ' 0H' + (W - c - k) + 'Q' + (W - c) + ' 0 ' + (W - c + d) + ' ' + d + 'L' + (W - d) + ' ' + (c - d) + 'Q' + W + ' ' + c + ' ' + W + ' ' + (c + k) + 'V' + (H - r) + 'Q' + W + ' ' + H + ' ' + (W - r) + ' ' + H + 'H' + r + 'Q0 ' + H + ' 0 ' + (H - r) + 'V' + r + 'Q0 0 ' + r + ' 0Z';
  }
  function sync() {
    document.querySelectorAll('.rr .cta').forEach(function (b) {
      var W = b.offsetWidth, H = b.offsetHeight; if (!W || !H) return;
      b.style.clipPath = 'path("' + ctaPath(W, H) + '")';
      b.style.setProperty('--cta-inner', 'path("' + ctaPath(W - 2, H - 2) + '")');
      b.setAttribute('data-cta-shaped', '');
    });
  }
  sync();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
  addEventListener('load', sync);
  addEventListener('resize', sync);
  if ('ResizeObserver' in window) { var ro = new ResizeObserver(sync); document.querySelectorAll('.rr .cta').forEach(function (el) { ro.observe(el); }); }

  /* Button feel: one sweep of light per press; a tick and an acid flash when an add-to-cart finishes without an error. */
  document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest && e.target.closest('.rr .cta'); if (!b || b.disabled) return;
    b.classList.remove('is-pressed'); void b.offsetWidth; b.classList.add('is-pressed');
    setTimeout(function () { b.classList.remove('is-pressed'); }, 620);
  }, { passive: true });
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (list) {
      list.forEach(function (m) {
        var b = m.target; if (!b.classList || !b.classList.contains('cta')) return;
        var was = (m.oldValue || '').split(' ').indexOf('loading') >= 0;
        if (!was || b.classList.contains('loading')) return;
        /* product-form.js clears aria-disabled after the class, and only when there was no error: look one tick later */
        setTimeout(function () {
          if (b.getAttribute('aria-disabled') === 'true') return;
          if (!b.querySelector('.cta-ok')) { var ok = document.createElement('i'); ok.className = 'cta-ok'; ok.setAttribute('aria-hidden', 'true'); b.appendChild(ok); }
          b.classList.add('is-done');
          setTimeout(function () { b.classList.remove('is-done'); }, 1100);
        }, 0);
      });
    });
    document.querySelectorAll('.rr .cta[type="submit"]').forEach(function (b) { mo.observe(b, { attributes: true, attributeFilter: ['class'], attributeOldValue: true }); });
  }
})();
